import { TimelineSlot } from '../Widget';
import { TimelineIdentifier } from './types';
import { interleave, TimelineBase } from './TimelineBase';

class LinearTimeline extends TimelineBase {
    /**
     * A boolean describing if the content is shuffled within the loop
     */
    private shuffle: boolean;

    /**
     * Type of the loop
     */
    private type: TimelineIdentifier;

    constructor(type: TimelineIdentifier, shuffle: boolean) {
        super();
        this.shuffle = shuffle;
        this.type = type;
    }

    protected buildTimelineLoop(): TimelineSlot[] {
        let slots: TimelineSlot[] = [];

        //make clone of widgets so original timeline widgets do not get removed
        let widgets = this.timelineWidgets.slice(0);
        const overrideWidget = this.getOverrideWidget(widgets);

        widgets = this.filterWidgets(widgets, overrideWidget);

        widgets.forEach((widget) => {
            let widgetSlots: TimelineSlot[] = [];

            //request content from the widget
            if (this.type === TimelineIdentifier.TIME_BASED) {
                //use minimum loop time on a widget to fill with slots
                widgetSlots = widget.querySlotsLinear(true);
            } else {
                widgetSlots = widget.querySlotsLinear();
            }

            if (widgetSlots.length > 0) {
                if (this.shuffle) {
                    //shuffle content
                    slots = interleave(slots, widgetSlots);
                } else {
                    slots = slots.concat(widgetSlots);
                }
            }
        });

        return slots;
    }
}

export { LinearTimeline };
